import { useCallback } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { CompleteUploadParams } from '@trinity/chat-components/containers/WorkspaceFileUpload/interfaces.js';

export const useCompleteFileUpload = () => {

  const apiClient = useChatApiClient();

  const completeUpload = useCallback((data: CompleteUploadParams) => {
    return apiClient.workspacesFileUpload.completeFileUpload({
      fileUploadId: data.fileUploadId,
      s3VersionId: data.s3VersionId,
      workspaceId: data.workspaceId,
    }).then(res => {
      return { fileUpload: res.fileUpload };
    });
  }, []);

  return completeUpload;
};

export default useCompleteFileUpload;